<script>
import utils from '@/utils/common';

import CommonDropdown from '../../CommonDropdown.vue';
import BaseCheckbox from '../../BaseCheckbox.vue';
import TaskViewActionsDispatcher from './TaskViewActionsDispatcher.vue';

export default {
  name: 'TaskViewFooterBar',
  components: { CommonDropdown, BaseCheckbox, TaskViewActionsDispatcher },
  props: {
    tasks: Array,
    selectedTasks: Array,
    hideToggleAll: Boolean,
  },
  data() {
    return {
      staticSelection: false,
      isOpenedMenu: false,
    };
  },
  mounted() {
    document.addEventListener('click', this.closeMenu);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.closeMenu);
  },
  computed: {
    menuItems() {
      const editable = this.selectedTasks.find(t => !t.canBeUpdated) === undefined;
      if (!editable) return [];

      const foundProjects = Object.values(
        this.selectedTasks.reduce((acc, val) => ({ ...acc, [val.project.id]: val.project }), {}),
      );

      const items = [];

      items.push({ text: 'Установить автора',             icon: 'edit-alt',       action: 'author',                   mode: null,    }); // eslint-disable-line
      items.push({ text: 'Установить исполнителя',        icon: 'edit-alt-1',     action: 'manager',                  mode: null,    }); // eslint-disable-line
      items.push({ text: 'Добвить наблюдателей',          icon: 'edit-alt-2',     action: 'members',                  mode: 'add',   }); // eslint-disable-line
      items.push({ text: 'Убрать наблюдателей',           icon: 'edit-alt-2',     action: 'deleteMembers',            mode: null,    }); // eslint-disable-line
      items.push({ text: 'Убрать участников',             icon: 'edit-alt-2',     action: 'deleteParticipants',       mode: null,    }); // eslint-disable-line
      items.push({ text: 'Изменить дату начала',          icon: 'edit-alt-3',     action: 'dateStart',                mode: null,    }); // eslint-disable-line
      items.push({ text: 'Изменить дату завершения',      icon: 'edit-alt-3',     action: 'dateFinish',               mode: null,    }); // eslint-disable-line
      items.push({ text: 'Изменить описание',             icon: 'edit',           action: 'description',              mode: null,    }); // eslint-disable-line
      items.push({ text: 'Изменить чеклист',              icon: 'edit',           action: 'checklist',                mode: null,    }); // eslint-disable-line

      if (foundProjects.length === 1) {
        items.push({ text: 'Изменить статус',               icon: 'edit',           action: 'status',                   mode: null,    }); // eslint-disable-line
      }

      items.push({ text: 'Изменить приоритет',            icon: 'edit',           action: 'priority',                 mode: null,    }); // eslint-disable-line
      items.push({ text: 'Закрыть задачи',                icon: 'close3',         action: 'close',                    mode: null,    }); // eslint-disable-line
      items.push({ text: 'Открыть задачи',                icon: 'open',           action: 'open',                     mode: null,    }); // eslint-disable-line
      items.push({ text: 'Удалить задачи',                icon: 'trash',          action: 'delete',                   mode: null,    }); // eslint-disable-line

      return items.map(item => ({ ...item, handler: () => this.change(item.action, item.mode) }));
    },

    selectedTasksWord() {
      return utils.pluralWord(this.selectedTasks.length, 'задача', 'задачи', 'задач');
    },

    checkBoxValue() {
      if (this.tasks.length === 0) {
        return false;
      }

      return this.tasks.length === this.selectedTasks.length;
    },
  },
  methods: {
    async change(action, mode) {
      const resolve = await this.$refs?.actionPopup?.open(action, mode);

      if (resolve) {
        this.$emit('update');
      }
    },

    closeMenu(e) {
      if (this.$refs.actions && !this.$refs.actions.contains(e.target)) {
        this.isOpenedMenu = false;
      }
    },
  },
};
</script>

<template lang="pug">
.b-task-view-footer-bar(:class="{ static: staticSelection }")
  TaskViewActionsDispatcher(:tasks="selectedTasks" ref="actionPopup")
  ._selected-value Выбрано:
    span  {{ selectedTasksWord }}
  ._selected-actions(ref="actions")
    Btn._button(:disabled="!selectedTasks.length || !menuItems.length" @click="isOpenedMenu = !isOpenedMenu" round blue) Действия
    CommonDropdown._dropdown(ref="dropdown" :items="menuItems" :isOpened="isOpenedMenu" @click.native="isOpenedMenu = false" dark noTriangle)
  ._checkbox(v-if="!hideToggleAll")
    BaseCheckbox(:value="checkBoxValue" :disabled="tasks.length <= 0" @input="$emit('toggleAllItems')" label="Все задачи" notColoredLabel)
</template>

<style scoped lang="scss">
.task-view-footer-bar {
  padding: 16px 0;
  display: grid;
  align-items: center;
  color: var(--color-white);
  background-color: #1E3147;
  //border-bottom: 1px solid rgba(223, 232, 255, 1);
  grid-template-columns: 330px 1fr max-content;

  &__selected-actions {
    position: relative;
  }

  &__dropdown {
    bottom: calc(100% + 20px);
    right: calc(100% - 60px);
  }

  &__selected-value {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;

    span {
      font-weight: 500;
    }
  }

  @media (max-width: 1000px) {
    grid-template-columns: 200px 1fr max-content;
  }

  @media (max-width: 576px) {
    grid-template-columns: 1fr max-content;
    gap: 20px;
    padding-bottom: 26px;
  }

  @media (max-width: 370px) {
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: stretch;
    padding: 14px 0 26px;

    &:before {
      content: '';
      display: block;
      width: 66px;
      height: 4px;
      background: #466E9C;
      align-self: center;
    }

    &__button {
      width: 100%;
    }

    &__selected-value {
      text-align: center;
    }
  }
}
</style>
